module.exports = __webpack_public_path__ + "img/tool-trapezoid.5063a6d9.svg";